// fastContext.ts
'use client';
import createFastContext from '../context/createFastContext';

export const { FastContextProvider:GlobalLoginContextProvide, useFastContextFields: useGlobalLoginContext } =
  createFastContext({
    openLoginSheet: false,
    navigationParams: {
      name: '',
      routeName: '',
      description: ``,
      screenName: '',
    },
    previousPage: null,
    previousSessionName: null,
  });
